import React, { memo } from "react";

import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";
import { UserKanbanBoardRole } from "@/generated/graphql";

/**
 * Props for BoardRoleBadgeView component
 */
interface BoardRoleBadgeViewProps {
  role: UserKanbanBoardRole;
}

/**
 * Minimal text indicator displaying user's role on the kanban board
 * Integrates subtly with the board name as metadata
 * @param root0 - Component props
 * @param root0.role - User's role on the board (VIEWER, EDITOR, or OWNER)
 */
const BoardRoleBadgeView = ({ role }: BoardRoleBadgeViewProps) => (
  <Stack direction="horizontal" className="items-center gap-1">
    <Text variant="unstyled" className="text-title-sm text-content-secondary">
      ·
    </Text>
    <Text variant="caption" className="text-content-muted">
      {
        {
          [UserKanbanBoardRole.Viewer]: "Viewer",
          [UserKanbanBoardRole.Editor]: "Editor",
          [UserKanbanBoardRole.Owner]: "Owner",
        }[role]
      }
    </Text>
  </Stack>
);

BoardRoleBadgeView.displayName = "BoardRoleBadgeView";

export default memo(BoardRoleBadgeView);
